import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'text';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  children: ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  isLoading = false,
  className = '',
  children,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#1A6B5A] text-white hover:bg-[#145245] focus:ring-[#1A6B5A] shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    secondary: 'bg-[#C4785B] text-white hover:bg-[#A6634B] focus:ring-[#C4785B] shadow-md hover:shadow-lg',
    outline: 'border-2 border-[#1A6B5A] text-[#1A6B5A] hover:bg-[#1A6B5A] hover:text-white bg-transparent',
    text: 'text-[#1A6B5A] hover:text-[#145245] underline-offset-4 hover:underline p-0 bg-transparent shadow-none'
  };
  const sizes = {
    sm: 'text-sm px-4 py-2',
    md: 'text-base px-8 py-3',
    lg: 'text-lg px-10 py-4'
  };
  // Override size for text variant
  const sizeClasses = variant === 'text' ? '' : sizes[size];
  return <button className={`${baseStyles} ${variants[variant]} ${sizeClasses} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-216">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-217" />}
      {children}
    </button>;
}